import { API } from '@/constant/constants'
import { DATA_PAGINATION } from '@/types/common'
import {
  GetStationsBasedOnLocationParams,
  LocationFiltered,
} from '@/types/program'
import { STATION_DETAIL } from '@/types/stations'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

export const stationsApi = {
  getAll(
    interfaceId: number,
    locationId?: number,
    floorId?: number,
    keyword?: string,
  ) {
    const url = API.OPERATIONS.STATION.DEFAULT.replace(
      ':interfaceId',
      `${interfaceId}`,
    )
    return axiosClient.get<STATION_DETAIL[]>(url, {
      params: {
        locationId,
        floorId,
        keyword,
      },
    })
  },

  getStationInfo(interfaceId: string) {
    const url = `/api/station/station-information?interfaceid=${interfaceId}`
    return axiosClient.get(url)
  },

  getStationsBasedOnLocation(
    interfaceId: number,
    params: GetStationsBasedOnLocationParams,
  ) {
    const url = API.OPERATIONS.STATION.BASED_LOCATION.replace(
      ':interfaceId',
      `${interfaceId}`,
    )
    return axiosClient.get<DATA_PAGINATION<LocationFiltered>>(
      url + queryStringify(params),
    )
  },

  getStationsBasedOn(
    interfaceId: number,
    params: GetStationsBasedOnLocationParams,
  ) {
    const url = API.OPERATIONS.STATION.BASED_STATION_LOCATION.replace(
      ':interfaceId',
      `${interfaceId}`,
    )
    return axiosClient.get<DATA_PAGINATION<LocationFiltered>>(
      url + queryStringify(params),
    )
  },
}

export default stationsApi
